'use client';

import type { Listing } from '@repo/api';
import { Breadcrumbs } from './Breadcrumbs';
import { UnitImageActions } from './UnitImageActions';

interface UnitHeaderProps {
  listing?: Listing | null;
  city?: string;
}

export function UnitHeader({ listing = null, city }: UnitHeaderProps) {
  return (
    <div className="sticky top-0 bg-primary" id="unit-header">
      {/* Breadcrumbs and Actions */}
      <div className="flex items-center justify-between gap-2 max-w-[1280px] px-6 md:px-16 py-3 w-full mx-auto">
        {/* Breadcrumbs */}
        <Breadcrumbs listing={listing} />

        {/* Action Container */}
        <div className="hidden md:flex gap-2 items-center justify-end shrink-0">
          <UnitImageActions listing={listing as Listing} variant="inline" />
        </div>
      </div>
    </div>
  );
}
